export const slimGreen = "#00cc21";
export const slimRed = "#cc0000";
export const slimYellow = "#FFFF00";
export const slimGrey = "#b3c1ce";
export const slimOrange = "#F2994A";
export const slimBlack = "#000000";
export const slimPurple = "#9DABDD";
export const slimGreenLight = "#cdf4e2";
export const slimGreenLight2 = "#86f3c1";
export const slimRedLight = "#ec8995";
export const slimGreyLight = "#e4e4e4";
export const slimGreenDark = "#068f4f";
export const slimRedDark = "#a02f3c";
export const emaPurple = "#800080";
export const emaOrange = "#F2994A";
export const emaBlue = "#6fbbd3";
export const asBlue = "#1A2BC3";